module.exports = __webpack_public_path__ + "img/highlights1-s.c818536f.png";